import { fetcher } from '@commenda/utils';

import { TCreateBillingQuoteParams } from './types';

export const createBillingQuote = async (params: TCreateBillingQuoteParams) => {
  const response = await fetcher('commenda-billing/quotes', {
    method: 'POST',
    body: params,
  });

  return response;
};
